import cookie from 'react-cookies';
const Authorization = 'Bearer ' + cookie.load('token');

export const builderSurfaceMultiPartHeader = (projectId) => {
  return {
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-project-id': projectId,
    },
  };
};

export const builderSurfaceJsonContentHeader = (
  projectId,
  token = false,
  userIp = '',
  envType = '',
) => {
  const headers = {
    'Content-Type': 'application/json',
    'x-project-id': projectId,
  };
  if (envType) {
    headers['x-project-env'] = envType;
  }

  if (token == true) {
    headers['token'] = Authorization;
  }

  if (userIp) {
    headers['userIp'] = userIp;
  }
  return { headers };
};
